const AMOUNT_PATTERN = /^\d{1,7}(\.\d{1,2})?$/;

/** Parses a CAD amount typed by an admin into exact cents; undefined when blank, null when invalid. */
export function parseCadToCents(value: string): number | undefined | null {
  // A French admin may type a decimal comma; accept it when there is no dot.
  const trimmed = value.trim().replace(/^(\d+),(\d{1,2})$/, '$1.$2');
  if (trimmed === '') return undefined;
  if (!AMOUNT_PATTERN.test(trimmed)) return null;
  const [dollars, cents = ''] = trimmed.split('.');
  return Number(dollars) * 100 + Number(cents.padEnd(2, '0'));
}

export function formatCadCents(cents: number, locale = 'en-CA'): string {
  return new Intl.NumberFormat(locale, { style: 'currency', currency: 'CAD' }).format(cents / 100);
}
